"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUESTION_MULTIPLE_CHOICE = exports.LIST = exports.QUESTION = exports.INTERACTION_LIST = exports.CAROUSEL_CONTROLS = exports.CAROUSEL_ARROW = exports.CAROUSEL = exports.MEDIA_GRID = exports.FORM_URL = exports.FORM = void 0;
var FORM = 'COrganismForm';
exports.FORM = FORM;
var FORM_URL = 'COrganismFormURL';
exports.FORM_URL = FORM_URL;
var MEDIA_GRID = 'COrganismMediaGrid';
exports.MEDIA_GRID = MEDIA_GRID;
var CAROUSEL = 'COrganismCarousel';
exports.CAROUSEL = CAROUSEL;
var CAROUSEL_ARROW = 'COrganismCarouselArrow';
exports.CAROUSEL_ARROW = CAROUSEL_ARROW;
var CAROUSEL_CONTROLS = 'COrganismCarouselControls';
exports.CAROUSEL_CONTROLS = CAROUSEL_CONTROLS;
var INTERACTION_LIST = 'COrganismInteractionList';
exports.INTERACTION_LIST = INTERACTION_LIST;
var QUESTION = 'COrganismQuestion';
exports.QUESTION = QUESTION;
var LIST = 'COrganismList';
exports.LIST = LIST;
var QUESTION_MULTIPLE_CHOICE = 'COrganismQuestionMultipleChoice';
exports.QUESTION_MULTIPLE_CHOICE = QUESTION_MULTIPLE_CHOICE;